const DEFAULT_EXPAND_VISIBLE_CATEGORIES_LENGTH = 1;

export const isOnlyOneCategoryVisible = (
    productCategories,
    getCategoryProducts,
    expandVisibleCategoriesLength = DEFAULT_EXPAND_VISIBLE_CATEGORIES_LENGTH
) => {
    if (!productCategories || productCategories.length === 0) {
        return false;
    }
    return (
        productCategories.filter((productCategory) => getCategoryProducts(productCategory.id).length > 0).length ===
        expandVisibleCategoriesLength
    );
};
